module.exports = __webpack_public_path__ + "img/840.db94d3df.svg";